import React from 'react';
import styles from './divider.module.css';

export function Divider(props: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div {...props} className={`${styles.divider} ${props.className || ''}`} />;
}
